import React from 'react';
import { Card, Typography, Avatar, Button, Space } from 'antd';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import './index.scss'

const { Title, Text } = Typography;

interface ContactInfoProps {
    name: string;
    role: string;
    avatarUrl: string;
    size?: number;
}

const getInitials = (name: string) => {
    let nameArray = name.split(' ');
    if (nameArray.length > 1) {
        return nameArray[0][0] + nameArray[nameArray.length - 1][0];
    }
    return name.split(' ').map(e => e[0]).join('');
}


const ProfileCard: React.FC<ContactInfoProps> = ({ name, role, avatarUrl, size }) => (
    <Space direction='horizontal' className='contact_info'>
        <Avatar src={avatarUrl} size={size ?? 48} >
            {avatarUrl ? '' : getInitials(name)}
        </Avatar>
        <div>
            <Title level={5} className='noLine'>{name}</Title>
            <Text type="secondary">{role}</Text>
        </div>
    </Space >
);

export default ProfileCard;
